import axios from "./axios";

export const getCurrentUser = () =>
  axios.get("/api/me").then(({ data }) => data.user);